import { truckListQuerySchema } from '@chukua/common';
import { Select } from 'antd';
import { useCallback, useEffect } from 'react';
import { useRemoteSearchOptions } from '../../../../../shared/hooks/use-remote-search-options';
import { getTruck, listTrucks } from '../trucks.api';

const PAGE_SIZE = 20;

interface TruckSearchSelectProps {
  id?: string;
  value?: string;
  onChange?: (value: string | undefined) => void;
  disabled?: boolean;
}

/** Remote-search truck picker: `GET /trucks?q=` by registration, make or model, opening on the first page. A saved `value` is fetched so its registration shows rather than its id. */
export function TruckSearchSelect({ id, value, onChange, disabled }: TruckSearchSelectProps) {
  const fetchTrucks = useCallback(
    (q: string | undefined) =>
      listTrucks(truckListQuerySchema.parse({ q, pageSize: PAGE_SIZE })).then((page) =>
        page.items.map((truck) => ({ value: truck.id, label: `${truck.registration} · ${truck.make} ${truck.model}` })),
      ),
    [],
  );
  const { pin, selectProps } = useRemoteSearchOptions(fetchTrucks);

  useEffect(() => {
    if (!value) return;
    getTruck(value).then((truck) => pin({ value: truck.id, label: `${truck.registration} · ${truck.make} ${truck.model}` }));
  }, [value, pin]);

  return (
    <Select
      {...selectProps}
      id={id}
      value={value}
      onChange={onChange}
      disabled={disabled}
      placeholder="Select or search trucks"
      notFoundContent={selectProps.loading ? 'Searching…' : 'No trucks found'}
    />
  );
}
